import api from './index';
//
let exports = {};

// 获取服务显示分类（tree）
exports.getServcDispCatList = function (postData, callback) {// 获取服务显示分类（Tree）
    api.post('/servcOper/disp/cat/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 更新 服务显示分类
exports.saveServcDispCat = function (postData, callback) {// 添加/修改 服务显示分类（节点）
    api.post('/servcOper/disp/cat/save/do')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.getServcDispCat = function (params, callback) {// 获取服务显示分类详细信息
    api.get('/servcOper/disp/cat/get')
    .params(params)
    .done(callback)
    .go();
};
// 判断是否有子类节点
exports.getServcDispCatByparentId = function (postData, callback) {// 根据父Id获取服务分类列表
    api.post('/servcOper/disp/cat/get/by/parentId')
    .data(postData)
    .done(callback)
    .go();
};
// 判断是否关联服务
exports.existServcDispCatRelServ = function (data, callback) {// 删除服务显示分类前检查是否存在关联服务
    api.post('/servcOper/disp/cat/rel/servc/exist')
    .data(data)
    .done(callback)
    .go();
};
// 删除
exports.deleteServcDispCat = function (params, callback) {// 删除服务显示分类
    api.post('/servcOper/disp/cat/delete/do')
    .params(params)
    .done(callback)
    .go();
};
// 排序
exports.moveServcDispCatSeq = function (postData, callback) {// 上下移系统商品分类条目
    api.post('/servcOper/disp/cat/seq/move/do')
    .data(postData)
    .done(callback)
    .go();
};
// 查看服务列表
exports.getServcDispCatRelPagedList = function (postData, callback) {// 获取显示分类信息关联的服务分页列表
    api.post('/servcOper/disp/cat/rel/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 设置服务分类回显
exports.getServcDisCatRelList = function (postData, callback) {// 服务显示分类关系列表（用于设置分类回显）
    api.post('/servcOper/disp/cat/rel/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 更新显示分类关系
exports.saveServcDispCatRel = function (postData, callback) {// 保存显示分类关联信息
    api.post('/servcOper/disp/cat/rel/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 服务显示分类关联 服务
exports.saveDispCatRelsForServc = function (postData, callback) {// 保存显示分类关联信息
    api.post('/servcOper/disp/cat/rels/for/servc/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务分类收费项目列表
exports.getServcTypeChargeItemList = function (postData, callback) {// 收费项目分页列表
    api.post('/servcOper/type/charge/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 获取服务分类收费项目信息
exports.getServcTypeChargeItem = function (postData, callback) {// 获取收费项目
    api.post('/servcOper/type/charge/item/get')
    .data(postData)
    .done(callback)
    .go();
};
// 保存服务分类收费项目
exports.updateServcTypeChargeItem = function (postData, callback) {// 添加收费项目
    api.post('/servcOper/type/charge/item/update/do')
    .data(postData)
    .done(callback)
    .go();
};
// 保存服务分类收费项目
exports.saveServcTypeChargeItemBatch = function (postData, callback) {// 添加收费项目
    api.post('/servcOper/type/charge/item/save/batch/do')
    .data(postData)
    .done(callback)
    .go();
};

//=================================服务楼层========================================

//保存服务楼层
exports.saveServcFloor = function (postData, callback) {// 保存服务楼层
    api.post('/servcOper/floor/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//查询服务楼层列表
exports.getServcFloorList = function (postData, callback) {// 查询服务楼层列表
    api.post('/servcOper/floor/get/list')
    .data(postData)
    .done(callback)
    .go();
};

//根据id查询服务楼层
exports.getServcFloor = function (params, callback) {// 根据id查询楼层信息
    api.get('/servcOper/floor/get')
    .params(params)
    .done(callback)
    .go();
};

//根据id删除楼层信息
exports.deleteServcFloor = function (params, callback) {// 根据id删除楼层信息
    api.post('/servcOper/floor/delete/do')
    .params(params)
    .done(callback)
    .go();
};

//保存服务楼层项
exports.saveServcFloorItem = function (postData, callback) {// 保存服务楼层项
    api.post('/servcOper/floor/item/save/do')
    .data(postData)
    .done(callback)
    .go();
};

//根据id查询楼层项信息
exports.getServcFloorItem = function (params, callback) {// 根据id查询楼层项信息
    api.get('/servcOper/floor/item/get')
    .params(params)
    .done(callback)
    .go();
};

//删除服务楼层项
exports.deleteServcFloorItem = function (params, callback) {// 删除楼层项信息
    api.post('/servcOper/floor/item/delete/do')
    .params(params)
    .done(callback)
    .go();
};
// 同步服务能力
exports.syncServcDevcCatRelByServicerShopId = function (data, callback) {// 删除楼层项信息
    api.post('/servcOper/servc/devc/cat/rel/sync/by/shopId')
    .data(data)
    .done(callback)
    .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcOper.js
// module id = 59
// module chunks = 1